import { render, staticRenderFns } from "./HeaderTimesheets.vue?vue&type=template&id=45f5f538&scoped=true&"
import script from "./HeaderTimesheets.vue?vue&type=script&lang=js&"
export * from "./HeaderTimesheets.vue?vue&type=script&lang=js&"
import style1 from "./HeaderTimesheets.vue?vue&type=style&index=1&id=45f5f538&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f5f538",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45f5f538')) {
      api.createRecord('45f5f538', component.options)
    } else {
      api.reload('45f5f538', component.options)
    }
    module.hot.accept("./HeaderTimesheets.vue?vue&type=template&id=45f5f538&scoped=true&", function () {
      api.rerender('45f5f538', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/EntryForCrew/Timesheets/HeaderTimesheets/HeaderTimesheets.vue"
export default component.exports